import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-architecture-challenge-drawer',
  templateUrl: './architecture-challenge-drawer.component.html',
  styleUrls: ['./architecture-challenge-drawer.component.scss']
})
export class ArchitectureChallengeDrawerComponent implements OnInit {
  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  showProofModal = false;

  close() {
    this.closed.emit();
  }

  constructor() { }

  ngOnInit() {
  }

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  setTime(date: any) {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  }

  formatDate(date: any) {
    return `${this.months[date.substring(5, 7).replace(/^0+/, '') - 1]} ${date.substring(8, 10).replace(/^0+/, '')}, ${date.substring(0, 4)}`;
  }

  formatMoney(value: number): string {
    if (value === null || value === undefined) { return '0'; }
    return value.toLocaleString('en-US');
  }

  getArchPercent(item: any): number {
    if (!item || !item.targetBooking) { return 0; }
    const pct = (item.achievedBooking / item.targetBooking) * 100;
    return pct > 100 ? 100 : Math.round(pct);
  }

  getProgressList(): any[] {
    const p = this.challenge && this.challenge.userArchActChProgress;
    return (p && p.architectureTargetsProgress) || [];
  }

  getTotalArchTarget(): number {
    const list = this.getProgressList();
    if (!list.length) { return 0; }
    let total = 0;
    for (let i = 0; i < list.length; i++) {
      total += list[i].targetBooking || 0;
    }
    return total;
  }

  trackByIndex(index: number) {
    return index;
  }

  getStatus(check: any, completedBy: any, creationDate: any, startDate: any) {
    var lang = localStorage.getItem('selectedLanguage');
    let value;
    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = this.setTime(completedBy.split('T')[0]);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (lang == 'Korean') {
      value = '열다';
      if (!check && isExpired) { value = '닫은'; }
      if (creationOn && pending) { value = '대기 중'; }
      if (check) { value = ''; }
    } else if (lang == 'Japanese') {
      value = '開いた';
      if (!check && isExpired) { value = '閉まっている'; }
      if (creationOn && pending) { value = '保留中'; }
      if (check) { value = ''; }
    } else {
      value = 'Open';
      if (!check && isExpired) { value = 'Closed'; }
      if (creationOn && pending) { value = 'Pending'; }
      if (check) { value = ''; }
    }
    return value;
  }
}
